import React from 'react';
import Lottie from 'lottie-react';
import BlockContainer from './BlockContainer';
import homepage from '../animations/homepage.json';

export default function ContentBlock({ title, subtitle, description }) {
  return (
    <BlockContainer
      bgColor="var(--midnight)"
      textColor="var(--text-light)"
      padding="80px"
    >
      <div className="lg:grid lg:grid-cols-2 lg:gap-16 justify-center items-center text-left">
        <div style={{ aspectRatio: '1/1', transform: 'scale(.9)' }}>
          <Lottie animationData={homepage} loop />
        </div>
        <div>
          <div className="w-[550px] max-w-full">
            {title ? (
              <h2 className="mb-6 text-4xl lg:w-[400px]">{title}</h2>
            ) : null}
            {subtitle ? <h3 className="text-xl mb-6">{subtitle}</h3> : null}
            {description ? (
              <p className="text-sm mb-[50px] lg:mb-0">{description}</p>
            ) : null}
          </div>
        </div>
      </div>
    </BlockContainer>
  );
}
